import { formatDate } from "utils/misc";

const convertValue = value => {
  switch (value) {
    case "false":
      return false;
    case "true":
      return true;
    default:
      return value;
  }
};

const getInitialValues = ({
  patientId,
  eligibleSupplies,
  supplyPeriodOptions,
  productLine,
  patientInfo,
  last_order,
  questions
}) => {

  var lastOrderAnswers = questions
    ?.filter(x => x.default_value == "last_order")
    .reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: convertValue(last_order?.questions[curr.id])
      }),
      {}
    );

  var defaultOrderAnswers = questions
    ?.filter(x => x.default_value && x.default_value !== "last_order")
    .reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: convertValue(curr.default_value)
      }),
      {}
    );

  const defaultDysfuctionAnswers = questions
    ?.filter(x => x.category.includes("Dysfunctions|"))
    ?.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: true
      }),
      {}
    );

  return {
    patient_id: patientId,
    supply_period: String(
      Array.isArray(supplyPeriodOptions)
        ? (supplyPeriodOptions[supplyPeriodOptions?.length - 1]?.value ?? 90)
        : 90
    ),
    product_line: productLine,
    order_create_method: "Web App",
    questions: {
      ...defaultOrderAnswers,
      ...lastOrderAnswers,
      ...defaultDysfuctionAnswers,
      address_change: false,
      insurance_change: false,
      additional_info: "",
      physician_change: false,
      change_in_supplies: false
    },
    requested_equipment: eligibleSupplies ?? [],
    physician: (() => {
      // Find physician from patient_product_lines by matching product line text
      const productLineEntry = patientInfo?.patient_product_lines?.find(
        entry => entry.text === productLine
      );
      
      if (productLineEntry?.physician) {
        const physician = productLineEntry.physician;
        return {
          npi: physician.npi || "",
          name: physician.name || "",
          address: {
            street_address: physician.address?.street_address || "",
            street_address2: physician.address?.street_address2 || "",
            city: physician.address?.city || "",
            zip: physician.address?.zip || "",
            state: physician.address?.state || ""
          },
          phone: physician.phone || "",
          fax: physician.fax || ""
        };
      }
      
      // Return empty physician structure if no product line match found
      return {
        npi: "",
        name: "",
        address: {
          street_address: "",
          street_address2: "",
          city: "",
          zip: "",
          state: ""
        },
        phone: "",
        fax: ""
      };
    })(),
    insurances:
      patientInfo?.insurances?.map(insurance => ({
        ...insurance,
        policy_start_date: formatDate(insurance.policy_start_date, "YYYY/MM/DD")
      })) ?? [],
    address: patientInfo?.address ?? {
      street_address: "",
      zip: "",
      state: ""
    }
  };
};

export default getInitialValues;
